import { render, staticRenderFns } from "./UserServices.vue?vue&type=template&id=6b309d96&scoped=true"
import script from "./UserServices.vue?vue&type=script&lang=js"
export * from "./UserServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b309d96",
  null
  
)

export default component.exports